import instance from "../../utils/axios"; // your shared axios instance

// Convert payload to FormData for consistent API format
const toFormData = (payload) => {
  const formData = new URLSearchParams();
  Object.entries(payload || {}).forEach(([key, val]) => {
    formData.append(key, val ?? "");
  });
  return formData;
};

// ✅ Save Church Video
export const saveChurchVideo = async (payload) => {
  const response = await instance.post(
    "/churches/churchvideos/save",
    toFormData(payload)
  );
  return response.data;
};

// ✅ Update Church Video
export const updateChurchVideo = async (payload) => {
  const response = await instance.post(
    "/churches/churchvideos/update",
    toFormData(payload)
  );
  return response.data;
};

// ✅ Delete Church Video
export const deleteChurchVideo = async ({ _id, churchvideoObjId, videoObjId }) => {
  const formData = new URLSearchParams();
  formData.append("_id", _id);
  formData.append("churchvideoObjId", churchvideoObjId);
  formData.append("videoObjId", videoObjId);

  const response = await instance.post(
    "/churches/churchvideos/delete",
    formData
  );

  return response.data;
};

// ✅ Read Church Videos
export const readChurchVideos = async (payload) => {
  const response = await instance.post(
    "/churches/churchvideos/read",
    toFormData(payload)
  );
  return response.data;
};
